import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { GlobalVariable } from 'src/app/providers/global/global';
import { Defect, DefectStatus, IDefectNote } from 'src/app/providers/models/user-cust-models';
import { RestProvider } from 'src/app/providers/rest/rest';
var ModalCancelDefectComponent = /** @class */ (function () {
    function ModalCancelDefectComponent(modalCtrl, global, rest, navCtrl) {
        this.modalCtrl = modalCtrl;
        this.global = global;
        this.rest = rest;
        this.navCtrl = navCtrl;
        this.isLoading = false;
        this.searchMessage = '';
        this.defectStatusObject = DefectStatus;
        this.cancellation = {
            id: null,
            cancellation_reason: null,
            cancellation_reason_description: '',
            status: null,
            vor: false
        };
        // Data passed in by componentProps
        this.currentDefect = null;
        this.cancellationReasonOptions = null;
    }
    ModalCancelDefectComponent.prototype.ngOnInit = function () {
        console.log('ModalVehicleDefectsComponent ngOnInit');
        // Get the defects from API
        this.getCancellationReasons();
    };
    ModalCancelDefectComponent.prototype.cancel = function () {
        return this.modalCtrl.dismiss(null, 'cancel');
    };
    ModalCancelDefectComponent.prototype.confirm = function () {
        return this.modalCtrl.dismiss(this.name, 'confirm');
    };
    ModalCancelDefectComponent.prototype.getCancellationReasons = function () {
        var _this = this;
        // console.log('getting Defects...', this.depots);
        this.isLoading = true;
        var wantedSearches = [];
        console.log('Cancellation reasons: ', wantedSearches);
        // const depots = this.depotFilter.value !== 'none' ? [this.depotFilter.value] : this.depots.map((x) => x = x.value).slice(1, this.depots.length);
        this.rest.DefectCancellationReasonsGet().then(function (res) {
            var cancellations = res.results;
            if (res.results && res.results.length > 0) {
                _this.cancellationReasonOptions = cancellations.map(function (c) {
                    return { value: c.id, label: c.reason };
                });
            }
            console.log('cancellation reasons Fetched', res);
            _this.isLoading = false;
            if (cancellations.length === 0) {
                _this.searchMessage = 'No defects found';
            }
        })
            .finally(function () {
            // if (this.refresher) {
            //   this.refresher.complete();
            // }
        });
    };
    ModalCancelDefectComponent.prototype.onCancellationReasonChange = function (event) {
        debugger;
        if (event) {
            this.cancellation.cancellation_reason = event;
        }
    };
    ModalCancelDefectComponent.prototype.click_cancel = function () {
        var _this = this;
        debugger;
        this.isLoading = true;
        var uuid = this.currentDefect.uuid;
        var payload = tslib_1.__assign({}, this.cancellation, { id: this.currentDefect['id'], status: DefectStatus.Cancel.id, vor: false });
        // Patch the defect with cancellation
        this.rest.CancelDefectUpdate(payload, this.currentDefect.uuid).then(function (result) {
            // this.rest.DefectCancel(this.currentDefect).then((result) => {
            debugger;
            _this.isLoading = false;
            _this.global.toast('Defect has been void');
            // Update the actions on defect
            _this.sendDefectStatusActionTrail(_this.currentDefect);
            _this.confirm();
        }).catch(function (error) {
            console.log('catch((error) ', error);
            _this.isLoading = false;
        });
        ;
    };
    ModalCancelDefectComponent.prototype.sendDefectStatusActionTrail = function (defect) {
        var _this = this;
        var actionComment = 'Defect has been void'; //this.global.getDefectStatusActionTrailText(defect);
        debugger;
        // if (actionComment !== '') {
        var defectAction = {
            defect: defect.uuid,
            comment: actionComment,
            user_generated: false,
            files: []
        };
        this.rest.DefectNotePost(defectAction).then(function (result) {
        }).catch(function (error) {
            _this.global.toast('Failed to post note.');
        });
        // }
    };
    return ModalCancelDefectComponent;
}());
export { ModalCancelDefectComponent };
